var map = {
	"./icn-agenda.svg": 535,
	"./icn-automotive.svg": 536,
	"./icn-b2b.svg": 537,
	"./icn-claimWizard-white.svg": 356,
	"./icn-claims.svg": 538,
	"./icn-clients.svg": 539,
	"./icn-contracts.svg": 540,
	"./icn-credit.svg": 541,
	"./icn-dsdocuments-blue.svg": 542,
	"./icn-dsdocuments-green.svg": 543,
	"./icn-dsdocuments-white.svg": 357,
	"./icn-dsdocuments.svg": 544,
	"./icn-family.svg": 545,
	"./icn-faq.svg": 546,
	"./icn-fire.svg": 547,
	"./icn-generali.svg": 548,
	"./icn-health.svg": 549,
	"./icn-home.svg": 550,
	"./icn-inbox-blue.svg": 551,
	"./icn-inbox-white.svg": 358,
	"./icn-inbox.svg": 552,
	"./icn-info.svg": 553,
	"./icn-life.svg": 554,
	"./icn-link_1x_blue.svg": 555,
	"./icn-links.svg": 556,
	"./icn-logout.svg": 557,
	"./icn-misc.svg": 558,
	"./icn-news.svg": 559,
	"./icn-no-result.svg": 23,
	"./icn-office.svg": 560,
	"./icn-outbox.svg": 561,
	"./icn-outline-location_on-24px.svg": 562,
	"./icn-production.svg": 563,
	"./icn-tasklist.svg": 564,
	"./icn-transport.svg": 565,
	"./icn-webapps.svg": 566,
	"./icn-willdoc.svg": 567,
	"./icn-workinjuries.svg": 568
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 262;



//////////////////
// WEBPACK FOOTER
// ./resources/images ^\.\/icn\-.*\.svg$
// module id = 262
// module chunks = 0